import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AccountsTableRow } from "../accountsView.types";
import styles from "../accountsView.module.scss";
import { AccountStatusCell } from "./AccountStatusCell";

export const StatusCell = ({
    row,
}: Readonly<CellContext<ViewTableFeatures, AccountsTableRow, unknown>>) => {
    const rowData = row.original;

    if (rowData.account) {
        return <AccountStatusCell account={rowData.account} />;
    }

    // Entity row: hide when expanded — details are visible on child account rows
    return <ViewTableCell className={styles.statusCell} />;
};

StatusCell.displayName = "StatusCell";
